import {connect} from 'react-redux';
import HeaderComponent from '../../Components/Layouts/Header';
import {userLogOut} from '../../redux/actions/AuthActions';
import {resetMerchantDetails} from '../../redux/actions/MerchantActions';
import { withRouter } from 'react-router';

const HeaderContainer = connect (
    (state) => {
        return {
            user: state.authReducer,
            userRoles: state.authReducer.info.userRoles,
            userInfo : state.authReducer.info
        };
    },
    (dispatch) => {
        return {
            userLogOut: () => {
                dispatch(userLogOut());
            },
            resetMerchantDetails: () => {
                dispatch(resetMerchantDetails());
            },
        };
    }
)(HeaderComponent);

export default withRouter(HeaderContainer);